import React from "react";
import { PieChart, Pie, Label, ResponsiveContainer, Tooltip } from "recharts";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { ChevronRightRounded } from "@mui/icons-material";
import { CircularProgress, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import Stack from "@mui/material/Stack";
import theme from "../styles/customTheme";
import axios from "axios";
import { getURLBase, updateParentHeight } from "../utils/helperFns";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Avatar from "@mui/material/Avatar";
import FolderIcon from "@mui/icons-material/Folder";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Grid from "@mui/material/Grid";
import "../styles/blinkingbutton.css";
import AccountsList from "../components/ui-components/AccountsList";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

class BalanceSummary extends React.Component {
  constructor(props) {
    super(props);
    this.url = getURLBase(true) + "/balancesummary";
    this.renewCheckurl = getURLBase(true) + "/reauthdetails";
    this.reauthCheck = getURLBase(true) + "/checkreauth";

    this.state = {
      isReady: false,
      blur: false,
      showAllAccounts: false,
      dense: false,
      secondary: false,
      renewAccountsList: [],
      totalAccountsPending: 0,
      open: false,
    };
  }

  componentDidMount() {
    if (!this.state.isReady)
      axios.post(this.url, { gid: this.props.gid }).then((response) => {
        this.processData(response.data.body);
        this.setState({ blur: response.data.body.blur });
      });

    axios.post(this.renewCheckurl, { gid: this.props.gid }).then((response) => {
      console.log(response.data.body);
      const { accounts } = response.data.body || [];

      console.log(accounts, "accoutnsss");

      // let acc = [
      //   {
      //     name: "HSBC Account Banking",
      //     connectionID: "A1",
      //     logo: "INVALID",
      //     type: "INVALID",
      //   },
      //   {
      //     name: "HSBC Account Banking PVT LTD",
      //     connectionID: "A1",
      //     logo: "INVALID",
      //     type: "INVALID",
      //   },
      // ];

      // this.setState({ renewAccountsList: acc });

      // this.processData(response.data.body);
      this.setState({ renewAccountsList: accounts });
    });

    axios.post(this.reauthCheck, { gid: this.props.gid }).then((response) => {
      console.log(response.data, "ashdsakjdnkjsahdasjkd");

      const { count, responseStatus } = response.data.body || {};
      if (count !== "") {
        let showAccounts = false;

        this.setState({ totalAccountsPending: count });
      }

      // console.log(accounts, "reauth check");
      // this.processDta(response.data.body);
    });
  }

  toggleAccountsScreen = () => {
    var showAllAccounts = this.state.showAllAccounts;
    showAllAccounts = !showAllAccounts;
    this.setState({ showAllAccounts: showAllAccounts });

    console.log(showAllAccounts, "scjknsasdfklnsajkdnasklnda");
  };

  generate = (element) => {
    return [0, 1, 2].map((value) =>
      React.cloneElement(element, {
        key: value,
      })
    );
  };

  processData = (response) => {
    let textdata = response.text;
    let piedata = [];

    let d = new Map(Object.entries(response.debit));
    let c = new Map(Object.entries(response.credit));
    let total = 0;

    for (const [k, v] of d.entries()) {
      total += parseFloat(v);
      // total += parseFloat(1212.65)
    }

    for (const [k, v] of c.entries()) {
      total -= parseFloat(v);
      // total -= parseFloat(1212.65)
    }

    piedata.push({ name: "total", value: parseInt(Math.abs(total)) });

    if (parseInt(Math.abs(total)) === 0) {
      piedata.push({ name: "", value: 1 });
    }

    this.setState({
      piedata: piedata,
      textdata: textdata,
      total: parseInt(total),
      isReady: true,
      // showAllAccounts: false,
    });
  };

  handleOpen = (openModal) => {
    console.log("hollaaa clicked");
    this.setState({ open: true });
  };

  render = () => {
    const CenterLabel = ({ viewBox, amount = 0 }) => {
      const { cx, cy } = viewBox;
      return (
        <React.Fragment>
          <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central">
            <tspan
              style={{
                fontWeight: 700,
                fontSize: "2rem",
                letterSpacing: "-0.08rem",
                fontFamily: "Nunito Sans",
              }}
            >
              £{amount}
            </tspan>
          </text>
        </React.Fragment>
      );
    };

    const COLORS = {
      ">0": theme.palette.success.main,
      "=0": theme.palette.gray[300],
      "<0": theme.palette.error.main,
    };

    const WidgetData = () => (
      <>
        {!this.state.showAllAccounts ? (
          <Card elevation={2} className={"widgetCard cardShadow "}>
            <Typography
              variant="h4"
              sx={{ fontWeight: 700 }}
              align="center"
              gutterBottom
            >
              Total Balance
            </Typography>
            <Divider light />

            {!this.state.isReady ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "20vh",
                }}
              >
                <CircularProgress color="success" />
              </Box>
            ) : (
              <>
                <CardContent
                  textAlign="center"
                  className={`${
                    this.state.isReady ? `${this.state.blur ? "blur" : ""}` : ""
                  }`}
                >
                  <Container className="chartContainer">
                    <ResponsiveContainer>
                      <PieChart>
                        <Pie
                          data={this.state.piedata}
                          labelLine={false}
                          outerRadius={100}
                          innerRadius={80}
                          fill={
                            this.state.total > 0
                              ? COLORS[">0"]
                              : this.state.total === 0
                              ? COLORS["=0"]
                              : COLORS["<0"]
                          }
                          paddingAngle={0}
                          dataKey="value"
                          verticalAlign="center"
                        >
                          <Label
                            content={<CenterLabel amount={this.state.total} />}
                            position="inside"
                          />
                        </Pie>
                        {Math.abs(this.state.total) > 0 ? (
                          <Tooltip key={""} />
                        ) : null}
                      </PieChart>
                    </ResponsiveContainer>
                  </Container>

                  <Box textAlign="center" my={2}>
                    <Button
                      component={Link}
                      variant="outlined"
                      endIcon={<ChevronRightRounded />}
                      to="/money"
                      disabled={this.state.blur}
                    >
                      See total Balance Breakdown
                    </Button>
                  </Box>

                  {this.state.totalAccountsPending > 0 && (
                    <Box
                      style={{
                        alignContent: "center",
                        display: "flex",
                        justifyContent: "center",
                      }}
                      textAlign="center"
                      my={2}
                    >
                      <Button
                        onClick={() => this.toggleAccountsScreen()}
                        type="submit"
                        class="button"
                      >
                        {this.state.totalAccountsPending}{" "}
                        {this.state.totalAccountsPending > 0
                          ? "Accounts"
                          : "Account "}{" "}
                        {" Need Renewal"}
                        <ChevronRightRounded
                          style={{ alignContent: "center" }}
                        />
                      </Button>
                    </Box>
                  )}

                  <Divider light />
                  <Stack
                    spacing={1}
                    direction={"row"}
                    sx={{ marginTop: { xs: "0.8rem", md: "50%" } }}
                  >
                    <Divider light />
                    <Box textAlign={"center"} width={"100%"}>
                      <Box margin={0}>
                        <Typography
                          variant="h5"
                          display="flex"
                          flexDirection="column"
                        >
                          <span
                            style={{
                              fontSize: "1.6rem",
                              margin: "auto",
                              fontWeight: 700,
                              textAlign: "center",
                            }}
                          >
                            {this.state.textdata}
                          </span>
                          <Typography
                            variant="body1"
                            display="inline"
                            sx={{ textAlign: "center" }}
                          >
                            of living expenses can be covered by this amount
                          </Typography>
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                </CardContent>
              </>
            )}
          </Card>
        ) : (
          <Card elevation={2} className={"widgetCard cardShadow "}>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <IconButton
                  aria-label="Close"
                  onClick={() => this.toggleAccountsScreen()}
                  style={{ marginBottom: 10 }}
                >
                  <ArrowBackIcon />
                </IconButton>
              </Grid>
              <Grid item xs={8}>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 700, marginTop: 1 }}
                  align="center"
                  gutterBottom
                >
                  Renew Access
                </Typography>
              </Grid>
            </Grid>

            <Divider light />

            {!this.state.isReady ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "20vh",
                }}
              >
                <CircularProgress color="success" />
              </Box>
            ) : (
              <>
                <CardContent
                  textAlign="center"
                  className={`${
                    this.state.isReady ? `${this.state.blur ? "blur" : ""}` : ""
                  }`}
                >
                  <AccountsList
                    heading={""}
                    subheading={"Status"}
                    accountDetails={this.state.renewAccountsList}
                    openDialog={this.props.handleOpen}
                    prefix={"Rs"}
                    gid={this.props.gid}
                  />

                  {/* <Box textAlign="center" my={2}>
                    <Button
                      component={Link}
                      variant="outlined"
                      endIcon={<ChevronRightRounded />}
                      to="/money"
                      disabled={this.state.blur}
                    >
                      See total Balance Breakdown
                    </Button>
                  </Box> */}

                  <Box textAlign="center" my={2}>
                    {/* <Button
                component={Link}
                variant="outlined"
                endIcon={<ChevronRightRounded />}
                to="/money"
                disabled={this.state.blur}
              >
                2 Accounts Need Renewal
              </Button> */}
                  </Box>

                  {/* <Divider light /> */}
                  <Stack
                    spacing={1}
                    direction={"row"}
                    sx={{ marginTop: { xs: "0.8rem", md: "50%" } }}
                  >
                    <Divider light />
                    <Box textAlign={"center"} width={"100%"}>
                      <Box margin={0}>
                        <Typography
                          variant="h5"
                          display="flex"
                          flexDirection="column"
                        >
                          <span
                            style={{
                              fontSize: "1.6rem",
                              margin: "auto",
                              fontWeight: 700,
                              textAlign: "center",
                            }}
                          >
                            {this.state.textdata}
                          </span>
                          <Typography
                            variant="body1"
                            display="inline"
                            sx={{ textAlign: "center" }}
                          >
                            of living expenses can be covered by this amount
                          </Typography>
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                </CardContent>
              </>
            )}
          </Card>
        )}
      </>
    );

    return <WidgetData />;
  };
}

export default BalanceSummary;
